import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

const getColor = {
  delay: {
    bgColor: colorPalette.orange95,
    color: colorPalette.orange35,
  },
  early: {
    bgColor: colorPalette.green95,
    color: colorPalette.green30,
  },
};

export const Tag = styled.span<{ status: string }>`
  color: ${(props) => getColor[props.status].color};
  background-color: ${(props) => getColor[props.status].bgColor};
  border-radius: 4px;
  padding: 4px;
`;
